import { Grid, Typography } from '@material-ui/core';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import React, { memo } from 'react';
import useGetUser from 'v2/hooks/useGetUser';
interface IProps {
  urlSun: string;
  urlChk: string;
}
const LinksClipBoard = ({ urlSun, urlChk }: IProps) => {
  const user = useGetUser();
  const showElements = !user?.is_elite && urlChk;
  const hasCampaing = urlSun.toLowerCase().includes('edzz.la') || urlChk.toLowerCase().includes('edzz.la');
  return (
    <>
      {showElements && (
        <Grid item md={6} xs={12}>
          <Typography component='h2' style={{ color: '#192542' }}>
            <strong>{hasCampaing ? 'URL Gerada:' : 'URL Novo Checkout Sun:'}</strong>
          </Typography>

          <CustomCopyToClipboard fullWidth text={urlChk} disableUnderline />
        </Grid>
      )}

      <Grid item md={6} xs={12}>
        <Typography component='h2' style={{ color: '#192542' }}>
          <strong>{hasCampaing ? 'URL Gerada:' : 'URL Checkout Sun:'}</strong>
        </Typography>

        <CustomCopyToClipboard fullWidth text={urlSun} disableUnderline />
      </Grid>
    </>
  );
};

export default memo(LinksClipBoard);
